// @ts-nocheck
import React from 'react';
import styled from 'styled-components';

import { Styles } from '../../config';



const Button = styled.div`
  position: relative;
  width: 55px;
  height: 55px;
  cursor: pointer;
  & div {
    position: absolute;
    width: 55px;
    border: 1px solid
      ${(props) => Styles.Color[props.color] || Styles.Color.quaternary};
  }

  & * {
    transition: all 300ms ease-in-out;
  }

  & div:nth-child(1) {
    top: 14px;
    left: 0;
  }
  & div:nth-child(2) {
    top: 28px;
    left: 0;
  }
  & div:nth-child(3) {
    top: 43px;
    left: 0;
  }

  ${(props) => {
    return props.isOpen
      ? `& div:nth-child(1) {
      top: 25px;
      -webkit-transform: rotate(135deg);
      -moz-transform: rotate(135deg);
      -o-transform: rotate(135deg);
      transform: rotate(135deg);
    }
  
    & div:nth-child(2) {
      opacity: 0;
      left: -60px;
    }
  
    & div:nth-child(3) {
      top: 25px;
      -webkit-transform: rotate(-135deg);
      -moz-transform: rotate(-135deg);
      -o-transform: rotate(-135deg);
      transform: rotate(-135deg);
    }`
      : '';
  }}
`;

const MenuButton = (props) => {
  return (
    <Button {...props}>
      <div></div>
      <div></div>
      <div></div>
    </Button>
  );
};

export default MenuButton;
